import { CalendarEvent, HyperlinkTarget } from '@/model';
import {
  GetNewsCalendarEventByIdResponse,
  GetNewsCalendarEventsItemResponse,
  GetNewsCalendarEventsResponse,
  PutNewsCalendarEventsResponse,
  PostNewsCalendarEventsResponse,
} from '@/services/response/calendar-events';

export class CalendarEventConverter {
  static toDomainFromGetItemResponse(response: GetNewsCalendarEventsItemResponse): CalendarEvent {
    return {
      uuid: response.uuid,
      business_unit_uuid: response.business_unit_uuid,
      name: response.name,
      place: response.place,
      event_at: response.event_at,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
      image_url: response.image_url,
    };
  }

  static toDomainFromPaginatedResponse(response: GetNewsCalendarEventsResponse): CalendarEvent[] {
    return response.data.map(CalendarEventConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostNewsCalendarEventsResponse): CalendarEvent {
    return {
      uuid: response.uuid,
      name: response.name,
      place: response.place,
      event_at: response.event_at,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPatchResponse(response: PutNewsCalendarEventsResponse): CalendarEvent {
    return {
      uuid: response.uuid,
      name: response.name,
      place: response.place,
      event_at: response.event_at,
      is_display: response.is_display,
      hyperlink: response.hyperlink,
      hyperlink_target: response.hyperlink_target ?? HyperlinkTarget.EXTERNAL,
      description: response.description,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetNewsCalendarEventByIdResponse): CalendarEvent {
    return {
      uuid: response.uuid,
      name: response.name,
      place: response.place,
      event_at: response.event_at,
      is_display: response.is_display,
      hyperlink: response.hyperlink,
      hyperlink_target: response.hyperlink_target ?? HyperlinkTarget.EXTERNAL,
      description: response.description,
      image_url: response.image_url,
      team_uuid: response?.team_uuid ?? undefined,
      team_name: response?.team_name ?? undefined,
      team_image: response?.team_image ?? undefined,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
